import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/SERVICIOS/auth.service';
import { DataDbService } from 'src/app/SERVICIOS/data-db.service';
import { SocketService } from 'src/app/SERVICIOS/socket/socket.service';
import { map, take, tap } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})

export class LoginComponent implements OnInit {
  codeError: any;
  messageError: any;
  isChecked: boolean;
  @ViewChild('myModal') myModal;
  modalRef;
  user: any;
  isLogin: boolean = false;

  constructor(private authSvc: AuthService, public modal: NgbModal,
    private afs: AngularFirestore, private router: Router,
    private dbdata: DataDbService, private socket: SocketService) { }

  ngOnInit(): void {
    //cerrar sesion
    this.authSvc.logout();
  }



  get email() { return this.loginForm.get('email') }
  get password() { return this.loginForm.get('password') }



  loginForm = new UntypedFormGroup({
    email: new UntypedFormControl('', Validators.required),
    password: new UntypedFormControl('', Validators.required)
  });
  async getUser(uid: string) {
    var data: any = await (await this.afs.collection('USERS').doc(uid).get().toPromise()).data();
    return data;

  }
  openLG3() {
    this.modalRef = this.modal.open(this.myModal, {
      size: "lg", animation: true, centered: true, backdrop: false
    })
  }

  removeModal() {
    this.modal.dismissAll()
    this.isChecked = false
  }

  acceptTerms() {
    this.afs.collection('USERS').doc(this.user.uid).set({ termsAndConditionsAccepted: true }, { merge: true }).then((e) => {
      if (this.user.role !== 'SUPPORT' && this.user.status) {
        this.router.navigate(['/pagina-principal']);
      } else {
        this.router.navigate(['/support']);
      }
      if (this.user && !this.user.status) {
        this.router.navigate(['/welcome']);
      } else if (this.user) {
        this.router.navigate(['/verification-email']);
      }

      this.removeModal()
    })
  }
  async onLogin() {
    if (this.loginForm.valid) {
      this.isLogin = true;
      this.counter();
      // if (this.isChecked == true) {
      const { email, password } = this.loginForm.value;

      try {
        const user = await this.authSvc.login(email, password);
        this.user = user



        this.afs.collection('USERS').doc(user.uid).valueChanges().pipe(take(1)).toPromise().then((userData: any) => {
          if (userData.tokens == null || userData.tokens == undefined) {


            this.afs.collection('USERS').doc(userData.uid).update({ 'tokens': [] })
          }
          if (userData.termsAndConditionsAccepted == null || userData.termsAndConditionsAccepted == undefined || userData.termsAndConditionsAccepted == false) {
            // this.router.navigate(['/terms-and-conditions']);
            this.openLG3()
            this.isLogin = false
          } else {
            if ((userData.role !== 'SUPPORT' && userData.role !== 'COMMUNITY-MANAGE') && userData.status == 'enabled') {
              this.router.navigate(['/pagina-principal']);
            } else if (userData.role == 'SUPPORT' && userData.status == 'enabled') {
              this.router.navigate(['/support']);
            } else if (userData.role == 'COMMUNITY-MANAGE' && userData.status == 'enabled' || userData.status == 'disabled') {
              this.router.navigate(['/welcome']);
            }
            if (userData && userData.status == 'undefined') {
              this.router.navigate(['/welcome']);
            } else if (userData.emailVerified == false) {
              this.router.navigate(['/verification-email']);
            }
          }
        })



        // let userData = await getUser(user.uid);





      }
      catch (error) {
        this.getError(error)
        this.isLogin = false
      }
      // }else{
      //   this.codeError ='terms no accepted'
      //   this.messageError = 'Acepta los términos y condiciones para continuar'
      // }
    } else {

    }
  }


  async loginWithPhone() {

    this.router.navigate(['/login-phone/login']);

  }

  counter() {
    let count = 15;
    let interval = setInterval(() => {
      count--
      if (count == 0) {
        this.isLogin = false;
        this.stopCount(interval)
      }

    }, 1000)

  }
  stopCount(interval) {
    clearInterval(interval);
  }

  getError(error: any) {
    // this.isLogin = false
    this.codeError = error.code;
    if (this.codeError === 'auth/user-not-found') {
      this.messageError = 'No hay ningún registro de usuario que corresponda a esta información. Es posible que se haya eliminado al usuario.';
    } else if (this.codeError === 'auth/wrong-password') {
      this.messageError = 'La contraseña no es correcta.';
    } else if (this.codeError === 'auth/invalid-email') {
      this.messageError = 'El correo electrónico no es válido.';
    } else {
      this.messageError = 'No se pudo iniciar sesión, revisa tu conexión a internet.';
    }

  }

  animation(e) {
    let value = e.target.value
    document.getElementById('i-email').setAttribute("value", value)
  }
  animationTwo(e) {
    let value = e.target.value
    document.getElementById('i-password').setAttribute("value", value)
  }

  checked(checked: boolean) {
    this.isChecked = checked;
  }


  // async querys(ref) {
  //   let sp = await ref.where("uid_user", '==', this.uid_user  ).get();
  //   sp.forEach(doc => {
  //     this.results.push(doc.data())
  //   });
  //   this.socket.io.emit("customers-incomplete",this.results, this.results.length-1, this.uid_user);
  // }

  isValidField(field: string): boolean {
    return (this.loginForm.get(field).touched || this.loginForm.get(field).dirty)
      && this.loginForm.get(field).valid

  }



}

